import * as React from "react";
import theme from "./theme.module.scss";
import {Icon, Tooltip} from "@vidazoo/ui-kit";
import {observer} from "mobx-react";

export interface IQuickFilterProps {
    item: any;
    onClick: (item) => void;
    iconName: string;
    tooltipTitle: string;
    children: any;
}

function QuickReportAction({children, item, onClick, iconName, tooltipTitle}: IQuickFilterProps) {

    const onIconClick = () => {
        onClick(item);
    };

    return (
        <div className={theme.quickFilter}>
            <Tooltip title={tooltipTitle} position="top">
                <span onClick={onIconClick} className={theme.icon} aria-label={tooltipTitle}>
                    <Icon iconName={iconName} size={1.5}/>
                </span>
            </Tooltip>
            {children}
        </div>
    );
}

export default observer(QuickReportAction);
